import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import LoginLeftBg from "../assets/images/login-left-bg.png";
import LoginRightTopBg from "../assets/images/login-right-top-bg.png";
import LoginRightBottomBg from "../assets/images/Right-bottom.png";
import forgotPassword2 from "../assets/images/forgotPassword2.png";
import signLogo from "../assets/images/signLogo.png";
import smallLogo from "../assets/images/smallLogo.png";
import { signinSchema } from "../Validations/AuthValidation";
import { useDispatch } from "react-redux";
import { routes } from "../helpers/constants";
import { useNavigate } from "react-router-dom";
import { reqToAdminLogin } from "../redux/slices.js/admins/adminsSlice";
import { EyeHideIcon, EyeShowIcon } from "../assets/icons";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const signInInitialValues = { email: "", password: "" };

  const handleSignIn = (values) => {
    const reqObj = {
      email: values.email,
      password: values.password,
    };
    dispatch(
      reqToAdminLogin({
        data: reqObj,
        onSuccess: (response) => {
          const userData = response?.data?.data;
          if (userData?.twofa_enabled) {
            navigate(routes.verifyauth);
          } else {
            navigate(routes.setUpAuth);
            // navigate(routes.dashboard);
          }
          // navigate(routes.dashboard);
        },
        onFailure: (error) => {},
      })
    );
  };
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="signup-page bg-white">
      <div className="container">
        <div className="signup-container h-screen flex items-center flex-wrap relative ">
          <div className="py-3 w-full lg:w-1/2 h-full hidden lg:flex">
            <div className="signup-left w-full h-full p-[20px] !px-[58px] xl:!pb-[42px] !pt-[106px] lg:flex items-start justify-between flex-col bg-blue relative rounded-[30px]">
              <img
                src={LoginLeftBg}
                alt="LoginLeftBg"
                className="absolute left-0 top-0 z-0"
              />
              <img
                src={LoginRightTopBg}
                alt="LoginRightTopBg"
                className="absolute right-0 top-0 z-0"
              />
              <img
                src={LoginRightBottomBg}
                alt="LoginRightBottomBg"
                className="absolute right-0 bottom-0 z-0"
              />
              <div className="signUpText flex flex-col gap-2">
                <h1 className="Sign-h1 font-roboto text-white m-0 ">
                  Welcome to
                </h1>
                <img src={signLogo} className="max-w-[368px]" alt="" />
                <p className="text-white m-0 text-[20px]">
                  Simplify your HR tasks with smart automation. From onboarding
                  to payroll, Monveta HR helps you manage people effortlessly —
                  without the complexity of corporate systems
                </p>
              </div>
              {/* <img src={signUpimg} alt="signup" className="mb-0 object-contain w-full z-0" /> */}
              <div className="w-full">
                <div className="relative inline-block px-[52px] py-[37px] bg-[#F8FFCF] text-left [clip-path:url(#statClip)] w-full">
                  <p className="text-h2 text-black mb-[24px] 2xl:mb-[30px] Rubik">
                    Rating Quality
                  </p>

                  <div className="flex items-center gap-3 justify-between">
                    <div className="flex-1">
                      <h2 className="text-black text-3xl mb-[24px] 2xl:mb-[30px]">
                        Tenant's
                      </h2>

                      <div className="text-black text-h3 Rubik ">
                        <div class="flex items-center mb-6">
                          <div class="flex -space-x-4 items-center mr-4">
                            <img
                              class="w-12 h-12 rounded-full border-2 border-white border-solid"
                              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
                              alt="User 1"
                            />
                            <img
                              class="w-12 h-12 rounded-full border-2 border-white border-solid"
                              src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
                              alt="User 2"
                            />
                            <img
                              class="w-12 h-12 rounded-full border-2 border-white border-solid"
                              src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face"
                              alt="User 3"
                            />
                          </div>

                          <div>
                            <div class="text-span text-black">120K+</div>
                            <div class="text-sub_span text-black">
                              Active users
                            </div>
                          </div>
                        </div>

                        <div class="w-full bg-blue rounded-full h-4 shadow-inner p-1">
                          <div
                            class="bg-yellow h-full rounded-full"
                            style={{ width: "40.5%" }}
                          ></div>
                        </div>
                      </div>
                    </div>

                    <div className="flex self-end">
                      <div className="w-[130px] h-[130px] rounded-full bg-[#4271D5] flex items-center justify-center text-white text-h1 shadow-lg -mb-[14px] -mr-[22px] ">
                        <div className="flex items-baseline gap-1">
                          <svg
                            width="32"
                            height="29"
                            viewBox="0 0 40 37"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 0L24.4903 13.8197H39.0211L27.2654 22.3607L31.7557 36.1803L20 27.6393L8.2443 36.1803L12.7346 22.3607L0.97887 13.8197H15.5097L20 0Z"
                              fill="#F8FFCF"
                            />
                          </svg>
                          <span className="text-white text-h1">4.5</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <svg width="0" height="0">
                    <defs>
                      <clipPath id="statClip" clipPathUnits="objectBoundingBox">
                        <path
                          d="
													M0,0.771
													C0,0.897,0.056,1,0.125,1
													H0.875
													C0.944,1,1,0.897,1,0.771
													V0.631
													C1,0.505,0.944,0.402,0.875,0.402
													H0.853
													C0.793,0.402,0.743,0.312,0.743,0.201
													C0.743,0.09,0.693,0,0.633,0
													H0.125
													C0.056,0,0,0.103,0,0.229
													V0.771Z
												"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`signup-right overflow-auto w-full lg:w-1/2 mx-auto md:px-[70px] px-4 h-full lg:pt-[118px] lg:pb-[88px] py-5 flex items-center justify-center flex-col`}
          >
            <div className="signup-right-title pb-[53px]">
              <h1 className="flex flex-wrap items-baseline gap-1 font-roboto mb-2 text-black text-h1">
                Welcome to
                <span>
                  <img src={smallLogo} alt="" />
                </span>
                Command Center
              </h1>
              <p className="text-p font-normal mb-0 text-gray">
                Centralized Control for Decentralized Teams.
              </p>
            </div>

            <div className={` w-full space-y-4`}>
              <Formik
                initialValues={signInInitialValues}
                validationSchema={signinSchema}
                onSubmit={handleSignIn}
              >
                {({ errors, touched }) => (
                  <Form className="signin-form space-y-5">
                    <div>
                      <label>
                        Email<span>*</span>
                      </label>
                      <Field
                        type="email"
                        name="email"
                        placeholder="Enter Email"
                        className="w-full"
                      />
                      {touched.email && errors.email && (
                        <div className="text-red-500 text-sm">
                          {errors.email}
                        </div>
                      )}
                    </div>

                    <div>
                      <label>
                        Password<span>*</span>
                      </label>
                      <div className="relative">
                        <Field
                          type={showPassword ? "text" : "password"}
                          name="password"
                          placeholder="Enter Password"
                          className="w-full pr-10 border rounded px-3 py-2"
                        />

                        <div
                          className="absolute right-3 top-[70%] transform -translate-y-1/2 cursor-pointer"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? EyeShowIcon : EyeHideIcon}
                        </div>
                      </div>
                      {touched.password && errors.password && (
                        <div className="text-red-500 text-sm">
                          {errors.password}
                        </div>
                      )}
                    </div>

                    <div
                      className="text-right w-fit ms-auto text-label text-[16px] text-[#0A204E] underline-offset-0 decoration-[0px] cursor-pointer"
                      onClick={() => navigate(routes.forgotPassword)}
                    >
                      Forgot Password?
                    </div>

                    {/* <div className="text-right text-label text-gray-400 underline underline-offset-0 decoration-[0px]" onClick={()=> navigate(routes.forgotPassword)}>
                          
                            Forgot Password?
                        </div> */}

                    <div className="pt-5">
                      <button type="submit" className="btn-yellow mx-auto">
                        Log In
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
